module.exports = __webpack_public_path__ + "media/fullinkVideo.9968573d.mp4";